module.exports = __webpack_public_path__ + "img/file05.5191b12f.png";